<template>
  <div v-if="hasCampaign" class="wrapper-filter">
    <div class="wrap-card tui ui form">
      <div class="form-field">
        <label>Busca por doador</label>
        <input v-model.trim="filter.nameOrDocumentNumber" type="search" placeholder="Busque por nome ou CPF" />
        <t-icon v-if="filter.nameOrDocumentNumber !== null"  class="icon-input" :icon="['fal', 'times']" @click="clearFilterName" />
        <t-icon v-else class="icon-input" :icon="['far', 'search']" />
      </div>
      <div class="form-field">
        <label>Status</label>
        <sui-dropdown
          v-model="filter.status"
          :options="status"
          placeholder="Selecione"
          search
          selection
        />
      </div>
      <div class="form-field">
        <label>Buscar por data de</label>
        <sui-dropdown
          v-model="filter.periodBy"
          :options="typeDate"
          placeholder="Selecione"
          search
          selection
        />
      </div>
      <div class="form-field">
        <label>No período de</label>

        <date-picker
          v-model='date'
          mode='range'
          locale="pt-Br"
          :input-props='{
            class: "input-date",
            placeholder: "Data",
            readonly: true
          }'
        />
        <t-icon class="icon-input" :icon="['far', 'calendar']" />
      </div>

      <button class="tui ui button primary button-uppercase fluid" @click="getFilter">FILTRAR</button>
      <button class="btn-link" @click.prevent="clearFilter">Limpar filtro</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    DatePicker: () => import('v-calendar/lib/components/date-picker.umd.js')
  },
  data() {
    return {
      clearName: 'hidden',
      filter:{
        nameOrDocumentNumber: null,
        status: null,
        periodBy: null,
        dateStart: null,
        dateEnd: null,
        campaignId: this.campaignId
      },
      date: {
        start: null,
        end: null
      },
      status: [
        { text: 'Expirado', value: 'expired' },
        { text: 'Falha na criação', value: 'fail_at_create' },
        { text: 'Falha no registro', value: 'fail_at_register' },
        { text: 'Importado', value: 'imported' },
        { text: 'Importando', value: 'importing' },
        { text: 'Pago', value: 'paid' },
        { text: 'Registrado', value: 'registered' },
        { text: 'Registrando', value: 'registering' },
        { text: 'Todos', value: null }

      ],
      typeDate: [
        { text: 'Importação', value: 'import' },
        { text: 'Registro', value: 'register' },
        { text: 'Pagamento', value: 'payment' },
        { text: 'Todos', value: null }
      ]
    }
  },

  computed: {
    ...mapState({
      campaignId: ({ campaign }) => campaign.campaign.id,
      listPeople: ({ people }) => people.listPeople.length,
      notFoundFilter: ({ people }) => people.notFoundFilter,
      hasCampaign: ({ campaign }) => campaign.campaign
    })
  },

  methods: {
    ...mapActions('people', ['getAllPeople', 'searchPeople', 'getKpi']),


    getFilter () {
      if (this.filter.nameOrDocumentNumber) {
        this.filter.nameOrDocumentNumber = this.filter.nameOrDocumentNumber.replace(/[/./-]+/g, '')
      }
      if (this.date) {
        this.filter.dateStart = this.date.start
        this.filter.dateEnd = this.date.end
      }
      this.$store.commit('people/SET_FILTER', this.filter)
      this.$store.commit('people/TOGGLE_ERROR_SEARCH', false)
      this.searchPeople({page: 1, limit: 50, ...this.filter, campaignId: Number(this.campaignId)})
      this.$store.commit('people/SET_KPI', [])
      this.getKpi({...this.filter, campaignId: Number(this.campaignId)})
    },

    clearFilter () {
      this.filter = {}
      this.date = {}
      this.date.start = null
      this.date.end = null
      this.getAllPeople({page: 1, limit: 50, campaignId: Number(this.campaignId)})
      this.$store.commit('people/TOGGLE_ERROR_SEARCH', false)
      this.getKpi({campaignId: Number(this.campaignId)})
    },

    clearFilterName () {
      this.filter.nameOrDocumentNumber = null
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.ui.search.dropdown {
  min-width: 100%;
}

.vc-title {
  text-transform: capitalize;
  color: $gray-700;
}

.btn-link {
  background-color: transparent;
  border: 0;
  color: $blue-500;
  padding: 0;
  cursor: pointer;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 15px;
  font-size: 12.8px;
  line-height: 18px;

  &:hover,
  &:focus {
    outline: none;
    box-shadow: none;
    color: $blue-700;
  }
}
</style>
